import type { AssetPool } from './types.js';

export function getSettlementPool(level: number): AssetPool {
  if (level <= 70)
    return {
      types: [
        'wheat',
        'fence',
        'sheep',
        'goat',
        'chicken',
        'bush',
        'ricePaddy',
        'pumpkin',
        'orchard',
        'appleTree',
        'pearTree',
        'trough',
        'haystack',
        'signpost',
      ],
      chance: 0.39,
    };
  if (level <= 75)
    return {
      types: [
        'wheat',
        'fence',
        'scarecrow',
        'cow',
        'cow',
        'sheep',
        'goat',
        'chicken',
        'horse',
        'donkey',
        'ricePaddy',
        'silo',
        'pigpen',
        'trough',
        'orchard',
        'appleTree',
        'lemonTree',
        'orangeTree',
        'beeFarm',
        'pumpkin',
      ],
      chance: 0.46,
    };
  if (level <= 78)
    return {
      types: [
        'barn',
        'sheep',
        'goat',
        'cow',
        'cow',
        'horse',
        'horse',
        'donkey',
        'wheat',
        'fence',
        'chicken',
        'cart',
        'ricePaddy',
        'silo',
        'pigpen',
        'haystack',
        'orchard',
        'appleTree',
        'oliveTree',
        'lemonTree',
        'peachTree',
        'beeFarm',
        'haybale',
      ],
      chance: 0.5,
    };
  if (level <= 84)
    return {
      types: [
        'tent',
        'hut',
        'house',
        'well',
        'fence',
        'sheep',
        'barrel',
        'tavern',
        'bakery',
        'stable',
        'garden',
        'doghouse',
        'shrine',
        'lantern',
        'woodpile',
      ],
      chance: 0.5,
    };
  if (level <= 90)
    return {
      types: [
        'house',
        'houseB',
        'church',
        'windmill',
        'well',
        'barrel',
        'torch',
        'tavern',
        'bakery',
        'stable',
        'garden',
        'laundry',
        'wagon',
        'shrine',
        'lantern',
        'signpost',
      ],
      chance: 0.55,
    };
  if (level <= 95)
    return {
      types: [
        'house',
        'houseB',
        'market',
        'inn',
        'windmill',
        'flag',
        'cobblePath',
        'torch',
        'gardenTree',
        'flower',
        'bush',
        'cathedral',
        'library',
        'clocktower',
        'statue',
        'park',
        'warehouse',
        'lantern',
      ],
      chance: 0.62,
    };
  return {
    types: [
      'castle',
      'tower',
      'church',
      'market',
      'inn',
      'blacksmith',
      'bridge',
      'flag',
      'cobblePath',
      'gardenTree',
      'flower',
      'fountain',
      'cathedral',
      'library',
      'clocktower',
      'statue',
      'park',
      'gatehouse',
      'manor',
      'warehouse',
      'lantern',
    ],
    chance: 0.72,
  };
}
